<template>
  <div class="venue-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i>首页
        </el-breadcrumb-item>
        <el-breadcrumb-item><i class="el-icon-office-building"></i>展馆展区管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主内容卡片 支付宝圆角卡片 -->
    <el-card class="main-card" shadow="hover">
      <!-- 头部操作区域 -->
      <div class="card-header">
        <div class="header-title">
          <i class="el-icon-s-data"></i>
          <span>展馆&展区信息管理</span>
        </div>
        <div class="header-actions">
          <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addData">
            新增展馆
          </el-button>
          <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addExhibitionArea">
            新增展区
          </el-button>
          <el-button size="mini" plain icon="el-icon-s-grid" @click="goCategory">
            分类管理
          </el-button>
        </div>
      </div>

      <!-- 搜索区域 支付宝多条件流式搜索 -->
      <div class="search-container">
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          label-width="80px"
          size="mini"
          class="search-form"
        >
          <el-form-item label="所属省市">
            <el-cascader
              ref="cascaderAddr"
              style="width: 180px"
              v-model="areaList"
              clearable
              filterable
              :props="propsdata"
              :key="isResouceone"
              @change="handleChangeAddress"
              placeholder="请选择省市"
            ></el-cascader>
          </el-form-item>

          <!-- 新增展区筛选 -->
          <el-form-item label="所属展区">
            <el-select
              v-model="searchForm.area_id"
              placeholder="全部展区"
              clearable
              filterable
              style="width: 140px"
            >
              <el-option
                v-for="item in exhibitionAreaList"
                :key="item.id"
                :label="item.area_name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="展馆名称">
            <el-input
              v-model="searchForm.name"
              placeholder="输入展馆名称/简称"
              clearable
              prefix-icon="el-icon-search"
              style="width: 160px"
            ></el-input>
          </el-form-item>

          <el-form-item label="展区名称">
            <el-input
              v-model="searchForm.exhibition_name"
              placeholder="搜索展区"
              clearable
              prefix-icon="el-icon-search"
              style="width: 140px"
            ></el-input>
          </el-form-item>

          <el-form-item label="展馆状态">
            <el-select v-model="searchForm.status" placeholder="全部状态" clearable style="width: 120px">
              <el-option label="全部" value=""></el-option>
              <el-option label="营业中" value="1"></el-option>
              <el-option label="已关闭" value="2"></el-option>
              <el-option label="维护中" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="面积范围">
            <el-select v-model="searchForm.areaRange" placeholder="全部面积" clearable style="width: 130px">
              <el-option label="全部" value=""></el-option>
              <el-option label="1000㎡以下" value="1"></el-option>
              <el-option label="1000-5000㎡" value="2"></el-option>
              <el-option label="5000-10000㎡" value="3"></el-option>
              <el-option label="10000㎡以上" value="4"></el-option>
            </el-select>
          </el-form-item>

          <!-- 展会行业拓展搜索字段 -->
          <el-form-item label="展会类型">
            <el-select v-model="searchForm.exhibition_type" placeholder="全部类型" clearable style="width: 130px">
              <el-option label="全部" value=""></el-option>
              <el-option label="消费展" value="1"></el-option>
              <el-option label="专业B2B展" value="2"></el-option>
              <el-option label="政企会展" value="3"></el-option>
              <el-option label="户外特展" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="适合规模">
            <el-select v-model="searchForm.scale_type" placeholder="不限规模" clearable style="width: 130px">
              <el-option label="不限" value=""></el-option>
              <el-option label="小型(≤500人)" value="1"></el-option>
              <el-option label="中型(500-3000人)" value="2"></el-option>
              <el-option label="大型(3000-10000人)" value="3"></el-option>
              <el-option label="超大型(万人以上)" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="配套设施">
            <el-select v-model="searchForm.support_type" placeholder="全部配套" clearable style="width: 130px">
              <el-option label="全部" value=""></el-option>
              <el-option label="标准展位" value="booth"></el-option>
              <el-option label="会议室" value="meeting"></el-option>
              <el-option label="停车场" value="park"></el-option>
              <el-option label="仓储物流" value="storage"></el-option>
              <el-option label="餐饮配套" value="food"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属商家">
            <el-input
              v-model="searchForm.shop_name"
              placeholder="商家名称"
              clearable
              style="width: 140px"
            ></el-input>
          </el-form-item>

          <el-form-item class="btns-group">
            <el-button size="mini" type="primary" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据表格 支付宝简约表格 -->
      <div class="table-container">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="mini"
          v-loading="loading"
          element-loading-text="数据加载中..."
          element-loading-spinner="el-icon-loading"
          :empty-text="emptyText"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" width="70" align="center">
            <template slot-scope="scope">
              <span class="table-index">{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <!-- 展馆名称+地址双行美化 -->
          <el-table-column label="展馆信息" width="300" :show-overflow-tooltip="false">
            <template slot-scope="scope">
              <div class="venue-name-cell">
                <div class="venue-name">{{ scope.row.title || '-' }}</div>
                <div class="venue-address" v-if="scope.row.address">
                  <i class="el-icon-location"></i>
                  {{ scope.row.address }}
                </div>
                <div class="venue-area-tag" v-if="scope.row.exhibition_area?.area_name">
                  <el-tag size="mini" type="info" effect="light">
                    展区：{{ scope.row.exhibition_area.area_name }}
                  </el-tag>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="展馆状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" size="mini" type="success" effect="light">营业中</el-tag>
              <el-tag v-else-if="scope.row.status === 2" size="mini" type="default" effect="light">已关闭</el-tag>
              <el-tag v-else size="mini" type="warning" effect="light">维护中</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="总面积" width="100" align="center">
            <template slot-scope="scope">
              <span class="num-text">{{ scope.row.area ? scope.row.area + '㎡' : '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="最大容纳" width="110" align="center">
            <template slot-scope="scope">
              <span class="num-text">{{ scope.row.capacity ? scope.row.capacity + '人' : '-' }}</span>
            </template>
          </el-table-column>

          <!-- 展会行业新增字段 -->
          <el-table-column label="展会类型" width="110" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.exhibition_type === 1">消费展</span>
              <span v-else-if="scope.row.exhibition_type === 2">专业B2B展</span>
              <span v-else-if="scope.row.exhibition_type === 3">政企会展</span>
              <span v-else-if="scope.row.exhibition_type === 4">户外特展</span>
              <span v-else class="empty-text">-</span>
            </template>
          </el-table-column>

          <el-table-column label="适合规模" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.scale_type === 1">小型展会</span>
              <span v-else-if="scope.row.scale_type === 2">中型展会</span>
              <span v-else-if="scope.row.scale_type === 3">大型展会</span>
              <span v-else-if="scope.row.scale_type === 4">超大型展会</span>
              <span v-else class="empty-text">-</span>
            </template>
          </el-table-column>

          <el-table-column label="配套设施" width="140" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag v-for="item in scope.row.support_arr || []" :key="item" size="mini" effect="light">
                  {{ getSupportLabel(item) }}
                </el-tag>
                <span v-if="!(scope.row.support_arr?.length)" class="empty-text">无配套</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="所属分类" width="120" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" type="primary" effect="light" v-if="scope.row.category">
                {{ scope.row.category.name }}
              </el-tag>
              <span v-else class="empty-text">未分类</span>
            </template>
          </el-table-column>

          <el-table-column label="所属商家" width="140" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.shop?.name || '未指定' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" width="170" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="280" fixed="right" align="center">
            <template slot-scope="scope">
              <div class="action-buttons">
                <el-button text type="primary" size="mini" @click="handleClick(scope.row)">编辑展馆</el-button>
               <el-button text type="info" size="mini" @click="openAreaDrawer(scope.row)">查看展区</el-button>
                <el-button text type="danger" size="mini" @click="del(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>


 <!-- 展区抽屉弹窗 -->
    <el-drawer
      title="展馆下属展区管理"
      :visible.sync="areaDrawerVisible"
      width="1200px"
      :before-close="closeAreaDrawer"
      destroy-on-close
    >
      <!-- 顶部展馆名称 + 新增按钮 -->
      <div class="drawer-header">
        <div class="drawer-venue-name">
          当前展馆：<span class="name-text">{{ currentVenue.title }}</span>
        </div>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addAreaFromDrawer">
          新增展区
        </el-button>
      </div>

      <!-- 展区表格 -->
      <div class="drawer-table-wrap">
        <el-table
          :data="areaTableData"
          border
          stripe
          size="mini"
          v-loading="areaLoading"
          empty-text="暂无展区数据，请新增"
        >
          <el-table-column type="index" label="序号" width="65" align="center">
            <template slot-scope="scope">
              {{ (areaPageNum - 1) * areaPageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="展区名称" prop="area_name" min-width="140" />
          <el-table-column label="展区面积(㎡)" prop="area_size" width="110" align="center" />
          <el-table-column label="容纳人数" prop="max_capacity" width="110" align="center" />
          <el-table-column label="标准展位" prop="booth_num" width="100" align="center" />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" size="mini" type="success" effect="light">正常可用</el-tag>
              <el-tag v-else-if="scope.row.status === 0" size="mini" type="warning" effect="light">维护关闭</el-tag>
              <el-tag v-else size="mini" type="default" effect="light">临时停用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="适配展会类型" prop="exhibition_type" width="130" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.exhibition_type === 1">消费零售展</span>
              <span v-else-if="scope.row.exhibition_type === 2">B2B专业展</span>
              <span v-else-if="scope.row.exhibition_type === 3">政企会展</span>
              <span v-else-if="scope.row.exhibition_type === 4">户外特展</span>
              <span v-else class="empty-text">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button text type="primary" size="mini" @click="editAreaFromDrawer(scope.row)">编辑</el-button>
              <el-button text type="danger" size="mini" @click="delAreaFromDrawer(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 展区分页 -->
      <div class="drawer-pagination">
        <el-pagination
          background
          @size-change="handleAreaSizeChange"
          @current-change="handleAreaPageChange"
          :current-page="areaPageNum"
          :page-sizes="[10,20,30]"
          :page-size="areaPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="areaTotal"
        />
      </div>

      <div slot="footer" class="drawer-footer">
        <el-button @click="closeAreaDrawer">关闭</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "VenueList",
  data() {
    return {
        areaDrawerVisible: false,
currentVenue: {},
areaLoading: false,
// 展区分页参数
areaTableData: [],
areaPageNum: 1,
areaPageSize: 10,
areaTotal: 0,

      areaList: [],
      isResouceone: false,
      // 地区级联配置
      propsdata: {
        checkStrictly: true,
        lazy: true,
        lazyLoad(node, resolve) {
          let url = '/api/api/cmp.sys.Region_read_lz/findRegionList';
          setTimeout(() => {
            const param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id'),
              parent_id: node.value
            }
            if (node.level === 0) param.parent_id = 1
            this.$axios.post(url, param).then((res) => {
              if (res.data.code === 200) {
                const nodes = res.data.data.map(item => ({
                  value: item.id,
                  label: item.name,
                  leaf: node.level >= 2
                }));
                resolve(nodes);
              }
            }).catch(() => resolve([]));
          }, 80);
        },
      },
      // 展区下拉数据源
      exhibitionAreaList: [],
      // 完整搜索表单（新增展会行业字段+展区）
      searchForm: {
        name: "",
        exhibition_name: "",
        area_id: "",
        shop_name: "",
        keyword: "",
        province_id: "",
        city_id: "",
        district_id: "",
        status: "",
        areaRange: "",
        exhibition_type: "",
        scale_type: "",
        support_type: ""
      },
      tableLoadData: [],
      loading: false,
      emptyText: "暂无展馆展区数据，请新增或更换搜索条件",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      showType: '',
      // 配套设施映射
      supportMap: {
        booth: "标准展位",
        meeting: "会议室",
        park: "停车场",
        storage: "仓储物流",
        food: "餐饮配套"
      }
    };
  },
  created() {
    this.showType = this.$route.query.showType;
    this.getExhibitionAreaList();
    this.DataList();
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return "-";
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  methods: {
    // 打开展区抽屉
openAreaDrawer(row) {
  this.currentVenue = row
  this.areaPageNum = 1
  this.getVenueAreaList()
  this.areaDrawerVisible = true
},

// 关闭抽屉
closeAreaDrawer() {
  this.areaDrawerVisible = false
  this.currentVenue = {}
  this.areaTableData = []
  this.areaPageNum = 1
  this.areaTotal = 0
  // 刷新展馆主列表（防止删除展区后数据不同步）
  this.DataList()
  // 刷新顶部展区下拉筛选
  this.getExhibitionAreaList()
},

// 分页获取当前展馆的展区
getVenueAreaList() {
  this.areaLoading = true
//   const params = {
//     access_token: sessionStorage.getItem('token'),
//     company_id: sessionStorage.getItem('company_id'),
//     venue_id: this.currentVenue.id,
//     pageNum: this.areaPageNum,
//     pageSize: this.areaPageSize
//   }
//   this.$axios.get('/api/venue/getVenueAreaPage', { params }).then(res => {
//     this.areaLoading = false
//     if (res.code === 200) {
//       this.areaTableData = res.data.data || []
//       this.areaTotal = res.data.total || 0
//     } else {
//       this.$message.error(res.msg || '获取展区列表失败')
//     }
//   }).catch(() => {
//     this.areaLoading = false
//     this.$message.error('网络异常')
//   })
},

// 每页条数切换
handleAreaSizeChange(size) {
  this.areaPageSize = size
  this.areaPageNum = 1
  this.getVenueAreaList()
},

// 页码切换
handleAreaPageChange(page) {
  this.areaPageNum = page
  this.getVenueAreaList()
},

// 抽屉内新增展区
addAreaFromDrawer() {
  this.areaDrawerVisible = false
  this.$router.push(`/exhibitionAreaForm?venue_id=${this.currentVenue.id}`)
},

// 抽屉内编辑展区
editAreaFromDrawer(row) {
  this.areaDrawerVisible = false
  this.$router.push(`/exhibitionAreaForm?id=${row.id}&venue_id=${this.currentVenue.id}`)
},

// 抽屉内删除展区
delAreaFromDrawer(row) {
  this.$confirm(`确定删除展区【${row.area_name}】？删除后不可恢复`, '删除提示', {
    type: 'warning',
    center: true
  }).then(() => {
    const params = {
      access_token: sessionStorage.getItem('token'),
      company_id: sessionStorage.getItem('company_id'),
      id: row.id
    }
    this.$axios.post('/api/venue/delExhibitionArea', params).then(res => {
      if (res.code === 200) {
        this.$message.success('展区删除成功')
        // 刷新当前展馆展区分页列表
        this.getVenueAreaList()
      } else {
        this.$message.error(res.msg)
      }
    })
  }).catch(() => {
    this.$message.info('已取消删除')
  })
},
    // 获取全部展区下拉
    getExhibitionAreaList() {
    //   const params = {
    //     access_token: sessionStorage.getItem('token'),
    //     company_id: sessionStorage.getItem('company_id')
    //   }
    //   this.$axios.get('/api/venue/exhibitionAreaList', { params }).then(res => {
    //     if (res.code === 200) this.exhibitionAreaList = res.data || []
    //   })
    },
    // 配套文字转换
    getSupportLabel(key) {
      return this.supportMap[key] || key
    },
    // 地区选择
    handleChangeAddress(value) {
      if (value && value.length > 0) {
        this.searchForm.province_id = value[0] || ''
        this.searchForm.city_id = value[1] || ''
        this.searchForm.district_id = value[2] || ''
      } else {
        this.searchForm.province_id = ''
        this.searchForm.city_id = ''
        this.searchForm.district_id = ''
      }
    },
    // 新增展馆
    addData() {
      this.$router.push({ name: 'venueForm' });
    },
    // 新增展区
    addExhibitionArea() {
      this.$router.push({ path: '/venueAreaForm' })
    },
    // 编辑展馆
    handleClick(row) {
      this.$router.push('/venueForm?id=' + row.id)
    },
    // 编辑展区
    editExhibitionArea(row) {
      if (!row.exhibition_area?.id) return this.$message.warning('该展馆未绑定展区，请先新增展区')
      this.$router.push('/venueAreaForm?id=' + row.exhibition_area.id + '&venue_id=' + row.id)
    },
    // 分类管理
    goCategory() {
      this.$router.push('/venueCategory')
    },
    // 加载列表
    DataList() {
      this.loading = true;
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        showType: this.showType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parent_id: sessionStorage.getItem('shop_id'),
        title: this.searchForm.name,
        exhibition_name: this.searchForm.exhibition_name,
        area_id: this.searchForm.area_id,
        shop_name: this.searchForm.shop_name,
        status: this.searchForm.status,
        province_id: this.searchForm.province_id,
        city_id: this.searchForm.city_id,
        district_id: this.searchForm.district_id,
        areaRange: this.searchForm.areaRange,
        exhibition_type: this.searchForm.exhibition_type,
        scale_type: this.searchForm.scale_type,
        support_type: this.searchForm.support_type
      }
      this.$axios.findVenueListP(param).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.tableLoadData = res.data.data || [];
          this.total = res.data.total || 0;
          this.emptyText = this.tableLoadData.length === 0 ? "暂无展馆展区数据，请新增或更换搜索条件" : "";
        } else {
          this.$message.error(res.msg || "获取展馆列表失败");
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error("网络请求异常，请稍后重试");
      })
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.pageNum = 1;
      this.DataList();
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.DataList();
    },
    searchSubmit() {
      this.pageNum = 1;
      this.DataList();
    },
    // 重置：清空地区级联、展区、所有搜索条件
    resetSearch() {
      this.searchForm = {
        name: "",
        exhibition_name: "",
        area_id: "",
        shop_name: "",
        keyword: "",
        province_id: "",
        city_id: "",
        district_id: "",
        status: "",
        areaRange: "",
        exhibition_type: "",
        scale_type: "",
        support_type: ""
      };
      this.areaList = [];
      this.pageNum = 1;
      this.DataList();
    },
    // 删除展馆（级联删除展区可后端控制）
    del(row) {
      this.$confirm('确定删除该展馆？关联展区数据将同步清除，无法恢复！', '删除风险提示', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'error',
        center: true
      }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: row.id,
        }
        this.$axios.venueDel(param).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.pageNum = 1;
            this.DataList();
            this.getExhibitionAreaList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(() => {
          this.$message.error("删除操作失败，请重试");
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    }
  }
};
</script>

<style scoped>
/* 支付宝全局基础配色 */
:deep(.el-card__header) {
  padding: 16px 20px !important;
}
:deep(.el-card) {
  border-radius: 8px;
  border: 1px solid #e5e6eb;
}
:deep(.el-button--primary) {
  background-color: #1677ff;
  border-color: #1677ff;
}
:deep(.el-tag--light) {
  background-color: #f0f7ff;
}
:deep(.el-table__row:hover > td) {
  background-color: #fafafa !important;
}
:deep(.el-pagination__btn:hover) {
  color: #1677ff;
}
:deep(.el-pagination__active) {
  background-color: #1677ff;
}

.venue-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
}

.breadcrumb-container {
  margin-bottom: 16px;
}

.main-card {
  border-radius: 8px;
  border: none;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 16px;
}

.header-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.header-title i {
  margin-right: 8px;
  color: #1677ff;
  font-size: 18px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.search-container {
  margin-bottom: 16px;
  background: #fafafa;
  padding: 12px 16px;
  border-radius: 6px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.table-container {
  margin-bottom: 16px;
}

/* 展馆名称单元格美化 */
.venue-name-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.venue-name {
  font-weight: 500;
  color: #1d2129;
  font-size: 13px;
}
.venue-address {
  font-size: 12px;
  color: #86909c;
  display: flex;
  align-items: center;
}
.venue-address i {
  margin-right: 4px;
}
.venue-area-tag {
  margin-top: 2px;
}

.num-text {
  color: #1677ff;
  font-weight: 500;
}
.time-text {
  color: #6b7785;
  font-size: 12px;
}
.empty-text {
  color: #c9cdd4;
}
.table-index {
  color: #86909c;
}
.tag-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 4px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

/* 移动端响应式 */
@media (max-width: 1440px) {
  .search-form .el-form-item {
    margin-bottom: 8px;
  }
}
@media (max-width: 768px) {
  .venue-container {
    padding: 10px;
  }
  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .header-actions {
    margin-top: 10px;
    flex-wrap: wrap;
  }
  .search-form {
    flex-direction: column;
    align-items: flex-start;
  }
  .search-form .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }
  .search-form .el-input,
  .search-form .el-select,
  .search-form .el-cascader {
    width: 100% !important;
  }
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

/* 展区抽屉样式 */
:deep(.el-drawer__header) {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}
:deep(.el-drawer__body) {
  padding: 16px 20px;
}
:deep(.el-drawer__footer) {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f2f5;
}
.drawer-venue-name {
  font-size: 14px;
  color: #6b7785;
}
.name-text {
  color: #1677ff;
  font-weight: 500;
  margin-left: 6px;
}
.drawer-table-wrap {
  margin-bottom: 16px;
}
.drawer-pagination {
  display: flex;
  justify-content: flex-end;
}
.drawer-footer {
  text-align: right;
}
</style>